/* eslint-disable no-nested-ternary */

function Wrapper({ condition, wrapper, children }) {
  return condition ? wrapper(children) : children;
}

export default Wrapper;
